import { data } from '../../data/configApp';
import { useToast } from './useToast';
import emailjs from "emailjs-com";

export function useEmail() {
  const { toastTitle, toastMessage, showToast, closeToast } = useToast();


  const sendEmail = async (mail, subject, message) => {
    console.log("📧 Enviando correo...",{mail,subject,message});
    const serviceID = data.VUE_APP_SERVICEID;
    const templateID = data.VUE_APP_TEMPLATEID;
    const userID = data.VUE_APP_USERID;

    try {
      const response = await emailjs.send(serviceID, templateID, {
        to_email: mail,
        subject: subject,
        message: message
      }, userID);

      return response.status === 200; // Éxito si el código es 200
    } catch (error) {
      console.error("❌ Error enviando correo:", error);
      return false;
    }
  };

  const handleSendMail = async (email,subject,message) => {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!isEmailValid) {
      showToast('Error', 'Por favor, ingresa un correo válido.');
      return;
    }

    try {
      const response = await sendEmail(email,subject,message);
      showToast(response ? 'Correo Enviado' : 'Error', response
        ? 'El correo ha sido enviado correctamente.'
        : 'Hubo un error al enviar el correo. Por favor, inténtelo de nuevo.');
    } catch (error) {
      showToast('Error', 'Hubo un error al enviar el correo. Por favor, inténtelo de nuevo.');
      console.error("❌ Error enviando solicitud:", error);
    }
  };

  return {
    sendEmail,
    handleSendMail,
    toastTitle,
    toastMessage,
    showToast,
    closeToast
  };
}